import { render, staticRenderFns } from "./LegacyWithMonth.vue?vue&type=template&id=6424391f&scoped=true"
import script from "./LegacyWithMonth.vue?vue&type=script&lang=js"
export * from "./LegacyWithMonth.vue?vue&type=script&lang=js"
import style0 from "./LegacyWithMonth.vue?vue&type=style&index=0&id=6424391f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6424391f",
  null
  
)

export default component.exports